import styled from 'styled-components';

import { RewardsManagement } from 'components/app-header/loyalty/rewards-management';
import { brandFont } from 'components/layout/brand-font';
import { THScanAndPay } from 'components/th-scan-and-pay';
import { primitive } from 'styles/constants/primitives';

export const RewardsTitleContainer = styled.div`
  width: 100%;
  padding: ${primitive.$spacing4} 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: inherit;
`;

export const RewardPoints = styled.div`
  font: ${brandFont.headerThree};
  color: ${primitive.th.$coffeeBrown};
  font-size: 1.25rem;
`;

export const ImageContainer = styled.div`
  height: 24px;
  flex: 1;
  & > div > img {
    width: unset !important;
    max-width: 100% !important;
  }
`;

export const StyledRewardsManagement = styled(RewardsManagement)`
  width: 100%;
`;

export const StyledScanAndPay = styled(THScanAndPay)`
  margin-top: 1rem;
  width: 100%;
`;

export const QRCodeContainer = styled.div`
  border-radius: 10px;
  background: white;
  padding: 2px;
  display: flex;
`;

export const QRCodeWrapper = styled.div`
  position: relative;
  border-radius: 6px;
  background: white;
  display: flex;
`;

export const BarcodeWrapper = styled.div`
  text-align: center;
  margin-bottom: 1rem;
`;

export const BarcodeStringTitle = styled.p`
  margin: 0;
  font-weight: ${Styles.fontWeight.heavy};
  color: ${primitive.th.$coffeeBrown};
`;

export const BarcodeContainer = styled.div`
  display: flex;
`;

export const BarcodeString = styled.textarea`
  color: ${primitive.th.$coffeeBrown};
`;

export const BarcodeCopyButton = styled.button`
  background: ${Styles.color.white};
  border: 0;
  height: 40px;
  width: 80px;
  cursor: pointer;
  color: ${Styles.color.primary};
  font-weight: ${Styles.fontWeight.heavy};
  font-family: ${Styles.fontFamily.base};
  &:hover {
    background-color: ${Styles.color.grey.six};
  }
  border-top: 1px solid ${Styles.color.primary};
  border-bottom: 1px solid ${Styles.color.primary};
  border-right: 1px solid ${Styles.color.primary};
`;

export const CardNumber = styled.p`
  font-weight: ${Styles.fontWeight.heavy};
  color: ${primitive.th.$coffeeBrown};
  margin: 0;
`;
